// removed by extract-text-webpack-plugin
module.exports = {"hikeColor":"#58924D","rideColor":"#C53426","runColor":"#0076C0","fitnessColor":"#375A92","walkColor":"#885291","container":"container-2pR7H","inner":"inner-1pYcQ","title":"title-7zg2x visuallyHidden-J2Vmg","list":"list-1vE6j","item":"item-27IKu","link":"link-1QR3z link-15H9R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/header/_shortcuts.css
// module id = 1235
// module chunks = 1